
import { defineComponent, ref, watchEffect, computed } from "vue";
import { useStore } from "vuex";
import { Field, ErrorMessage } from "vee-validate";
import Editor from "@tinymce/tinymce-vue";
import Documents from "@/views/pages/application/document/Document.vue";
import DocumentsRO from "@/views/pages/application/view/tabs/Document.vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep1 {
  strategy: string;
  areChosenFromRecord: string;
  approvedPerson: string;
  hasIdentifiableInformation: string;
  identifiableInformation: string;
  hasAccess: string;
}

export default defineComponent({
  name: "step-1",
  components: {
    Field,
    Editor,
    ErrorMessage,
    Documents,
    DocumentsRO,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    const step1 = ref<IStep1>({
      strategy: "",
      areChosenFromRecord: "0",
      approvedPerson: "",
      hasIdentifiableInformation: "0",
      identifiableInformation: "",
      hasAccess: "0",
    });

    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const submit = () => {
      if (!submitButtonRef.value) {
        return;
      }
    };

    watchEffect(() => {
      const data = store.getters.currentRecruitment;
      if (data === null || data.data === undefined) return;
      step1.value.strategy = data.data.strategy || "";
      step1.value.areChosenFromRecord = data.data.areChosenFromRecord
        ? "1"
        : "0";
      step1.value.approvedPerson = data.data.approvedPerson || "";
      step1.value.hasIdentifiableInformation = data.data
        .hasIdentifiableInformation
        ? "1"
        : "0";
      step1.value.identifiableInformation =
        data.data.identifiableInformation || "";
      step1.value.hasAccess = data.data.hasAccess ? "1" : "0";
    });

    return {
      submit,
      submitButtonRef,
      step1,
      Editor,
      Documents,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
